<template>

    <b-container>
      <b-col lg="10" offset-lg="1">
        <h1 class="font-weight-light text-center text-lg-left mt-2 mb-0">{{ item.name }}</h1>
        <hr class="mt-2 mb-2">
        <div align="left" class="mb-2">
          <b-badge align="left" v-for="area in item.areas" :key="area.id" pill variant="secondary" class="mr-1">
            <router-link style="text-decoration: none; color: white" :to="{name: 'gallery', query:{area:area.name}}">{{ area.name }}
            </router-link>
          </b-badge>
          </div>
       <div v-if="item.video_id!=''">
        <b-row>
      <VideoPlus :id="id" :item="item"/>
           <b-col cols="2" v-if="banner">
             <b-img class="mt-2" :src="banner"></b-img>
           </b-col>
        </b-row>
       <b-row>
           <b-col align="center" class="my-3">
             <font-awesome-icon v-if="!upvote" v-on:click="thumbsUp" :icon="[ 'far', 'thumbs-up' ]" size="2x" class="mr-2"/>
             <font-awesome-icon v-if="upvote" v-on:click="thumbsUp" :icon="[ 'fa', 'thumbs-up' ]" size="2x" class="mr-2"/>
             <font-awesome-icon v-if="!downvote" v-on:click="thumbsDown" :icon="[ 'far', 'thumbs-down' ]" size="2x" class="mr-2"/>
             <font-awesome-icon v-if="downvote" v-on:click="thumbsDown" :icon="[ 'fa', 'thumbs-down' ]" size="2x" class="mr-2"/>
             <b-badge :style="{backgroundColor:$store.state.globalTheme.DEFAULT_COLOR}" v-if="votes!=0 || downvote || upvote" align="left" pill variant="secondary" class="mr-1 py-2" style="vertical-align: super">Rated: {{ votes }}</b-badge>
         </b-col>
        </b-row>
            <b-card no-body>
              <b-tabs content-class="mt-3" card>
            <b-tab title="Description" active>
              <b-card-title>{{ item.name }}</b-card-title>
            <b-card-text>
             {{ item.description }}
            </b-card-text>
                </b-tab>
                <b-tab v-if="handouts.length" title="Handouts">
                  <li style="text-align: left;" v-for="h in handouts" :key="h.id"><a :href="h.url" target="_blank">{{ h.name }}</a></li>
                </b-tab>
            </b-tabs>
  </b-card>
      </div>
        <JoinToday v-else-if="!$store.getters.loggedIn" title="Join To View This Video" :url="$route.fullPath"/>
        <div v-else>
          <b-card>
            <b-card-sub-title style="font-size: large">Sorry you don't have access to this resource</b-card-sub-title>
            <b-row class="my-4">
              <b-col offset="2" cols="4">
            <b-button :to="{name:'voucher'}">Have a Voucher?</b-button>
                </b-col>
              <b-col cols="4">
            <b-button>Buy a Subscription</b-button>
              </b-col>
            </b-row>
    <b-card-text>

     {{ item.description }}
    </b-card-text>
  </b-card>

        </div>

</b-col>

    <b-row>

    <b-container fluid>
      <b-col align="left" cols="10" offset="1" class="mt-4">
        <h5><b-badge pill align="left" class="mb-4">Related</b-badge></h5>
      <carousel :centerMode="true" :navigationEnabled="true" :paginationEnabled="false" :perPageCustom="[[576, 3],[768, 4],[992, 4]]" :navigationClickTargetSize="1">
        <slide v-for="s in items" :key="s.id">
          <Highlight :name="s.name" :logo="s.logo" :id="s.id" />
        </slide>
      </carousel>
      </b-col>
    </b-container>
  </b-row>


  <b-modal id="modal-1" size="sm" :title="'Interested in ' + topic + '?'" centered footer-class="p-2 border--0" style="justify-content: center">
    <b-img :src="company_logo" style="max-height: 10rem; max-width: 15rem"></b-img>
    <b-form>
      <p>Like to hear more about {{ topic }} from our supporter {{ company }}?</p>
        <b-form-checkbox
      id="checkbox-1"
      v-model="share"
      name="checkbox-1"
      size="md"
    >
     Click to allow {{company }} to contact me
    </b-form-checkbox>
    </b-form>
     <template v-slot:modal-footer="{ ok }">
       <b-button block size="sm" variant="success" @click="ok()">
        OK
      </b-button>
    </template>
  </b-modal>
</div>
    </b-container>
</template>
<script>
import VideoPlus from './video_plus.vue'
import JoinToday from "./JoinToday.vue";
import { getAPI } from '../store/axios-base'
import Highlight from "./Highlight.vue";

    export default {
        props :['id'],
        components:{
            VideoPlus,
            JoinToday,
            Highlight
        },
        data:() => {
            return {
                item:{'video_id':null},
                items:[],
                handouts:[],
                upvote: false,
                downvote: false,
                votes: 0,
                voted: 0,
                topic:'',
                company:'',
                company_logo:'',
                share: false,
                banner: '',
            }
        },
        mounted:function(){
            console.log(this.$route.fullPath)
          window.scrollTo(0,0);
          this.FetchData();
        },
        watch:{
          share (newvar, oldvar) {
          this.agreeShare()
          },
          item(newvar,oldvar){
            this.FetchRelated();

          }
        },
        methods:{
            thumbsUp:function(){

              if(this.voted != 1 && !this.upvote){
                  this.votes = this.votes +1
              }
              this.upvote = true;
              this.downvote = false;
              this.voted = 1
              this.vote();
            },
            thumbsDown:function(){
              if(this.voted != -1 && !this.downvote){
                  this.votes = this.votes -1
              }
              this.upvote = false;
              this.downvote = true;
              this.voted = -1;

              this.vote();
            },
            vote:function(){
              if(this.$store.getters.loggedIn) {
              var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }
              getAPI.post("/api/v1/vote/",{record_id: this.id, upvote: this.upvote, downvote:this.downvote},{ headers: headers }).then(response => {
                  console.log(response.data);
                });
              }
            },
            agreeShare:function(){
              if(this.$store.getters.loggedIn) {
              var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }
              getAPI.post("/api/v1/share/",{record_id: this.id,share:this.share},{ headers: headers }).then(response => {
                  console.log(response.data);
                });
              }
            },

            showCompany:function(){
                if(this.company && this.topic && !this.share){
                    setTimeout(()=> this.$bvModal.show('modal-1'),
                    5000
                    )
                }
            },
            FetchData:function(){
               if(this.$store.getters.loggedIn) {
            var headers = { Authorization: `Bearer ${this.$store.state.accessToken}` }
              } else {
              var headers = {}
              }

            getAPI.get("/api/v1/session/" + this.id,{ headers: headers }).then(response => {
            this.item = response.data
            this.handouts = response.data.handouts
            this.downvote = response.data.downvote
            this.upvote = response.data.upvote
            this.votes = response.data.votes
            this.topic = response.data.topic
            this.company = response.data.company
            this.company_logo = response.data.company_logo
            this.share = response.data.share
            this.banner = response.data.banner
            this.showCompany();
            console.log(response.data)
          });
        },
          FetchRelated: function () {
          var headers = {}

          var areas =  this.item.areas.map(({ id }) => id);

          getAPI.get("/api/v1/sessions/?page=1&areas=" + areas, {headers: headers}).then(response => {
              this.items = response.data.items
          });
          },
        },
    }
</script>

<style scoped>

    .video {
  max-height: 600px;
}

.badge-secondary {
  background: var(--main-color)
}

h1 {font-size:1rem;}
h4 {font-size:0.8rem;}
.card-text {font-size:0.5rem;}

@media (min-width: 544px) {
  h1 {font-size:1.5rem;}
  h4 {font-size:1.4rem;}
  .card-text {font-size:1rem;}

}

@media (min-width: 768px) {
  h1 {font-size:2rem;}
  h4 {font-size:1.8rem;}
  .card-text {font-size:1.2rem;}
}


</style>



// WEBPACK FOOTER //
// src/components/Video.vue